<template>
    <div class="message">
        <div class="message-container" :class="{full: message.media && message.media.length > 0}">
            <div 
                v-if="showUser && message.user"
                class="message__avatar"
                @click.stop="openUser(user.id)" 
                :style="{ backgroundImage: 'url(' + getAvatar(user) + ')' }"
                :title="user.firstname + ' ' + user.lastname">
            </div>
            <div class="message__content">
                <p v-html="getMessage(message.message)"></p>
                <p class="message__time">{{ getTime(message.time) }} {{message.edited ? ' (ред.)' : ''}}</p>
                <div class="message__viewed">
                    <Loader v-if="message.loading" color="#5b769e" :size="18" />
                    <img v-else-if="viewed" src="@/assets/images/icons/check_two.svg">
                    <img v-else-if="!viewed" src="@/assets/images/icons/check_one.svg">
                </div>
                <!-- Replies -->
                <div class="message__replies" v-if="message.replies && message.replies.length > 0">
                    <div class="message" v-for="reply in message.replies" :key="reply.id">
                        <div class="message__content" >
                            <div 
                                v-if="reply.user"
                                @click="openUser(reply.user.id)" 
                                class="message__name">
                                {{reply.user.firstname}}
                            </div>
                            <p v-html="getMessage(reply.message)"></p>
                            <p class="message__time">{{ getTime(message.time) }} {{message.edited ? ' (р.)' : ''}}</p>
                        </div>
                    </div>
                </div>
                <router-link :to="{name: 'place', params: {hash: `${place.id}&${place.hash}`}}" class="message-place" v-if="place">
                    <div class="message-place__cover" :style="{backgroundImage: 'url(' + place.cover + ')'}"></div>
                    <div class="message-place__content">
                        <h4 class="message-place__title">{{place.title}}</h4>
                        <p class="message-place__text">{{place.country}}, {{place.state}}</p>
                    </div>
                </router-link>
                <div class="message-media" v-if="message.media && message.media.length > 0">
                    <div class="message-media__item" 
                        v-for="(media, index) in message.media" 
                        :key="media.id" 
                        :style="{backgroundImage: `url(${ media.url })`}"
                        @click.stop="showFullPhoto($event, message.media, index)"
                        :class="[getImageClass(message.media), media.orientation]" 
                    >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {escapeEmoji} from '../helpers/encodes.js'
export default {
    name: 'Message',
    props: {
        message: {
            type: Object,
            require: true
        },
        user: {
            type: Object,
            require: true
        },
        showUser: {
            type: Boolean,
            require: false,
            default: true
        },
        users: {
            type: Array,
            require: true
        }
    },
    components:{
        Loader: () => import('@/components/UI/Loader'),
    },
    data: () => {
        return {
            place: null
        }
    },
    computed: {
        getUser() {
            return this.$store.getters.getAuthUser
        },
        viewed () {
            let viewed = false;
            this.users.forEach(user => {
                let finded = user.id == this.message.user.id ? true : this.message.viewed.find(view => view && view.user === user.id);
                finded ? false : viewed = true;
            });
            return viewed
        }
    },
    methods: {
        getAvatar(user) {
            return user.deleted ? require('@/assets/images/defaults/dead.svg') : user.avatar
        },
        getTime(time) { 
            return this.$moment(time).format('HH:mm')
        },
        openUser(id) {
            let link = this.$router.resolve({
                name: "user",
                params: { id },
            });
            window.open(link.href, "_blank");
        },
        getMessage(message) {
            !this.place ? this.hasPlace(message) : '';
            return escapeEmoji(this.escapeLinks(message));
        },
        escapeLinks(message) {
            const regexp = new RegExp(/([^"=]{2}|^)((https?|ftp):\/\/\S+[^\s.,> )\];'"!?])/g);
            const subst = '$1<a href="$2" target="_blank">$2</a>'; 
            return message.replace(regexp, subst);
        },
        hasPlace(message) {
            let has = message.indexOf('https://wiildwood.online/places/');
            let splitted = has !== -1 ? message.split('https://wiildwood.online/places/')[1] : '';
            let splitted_space = splitted && splitted.indexOf(' ') ? splitted.split(' ')[0] : splitted;
            let splitted_data = splitted_space && splitted_space.indexOf('&') ? splitted_space.split('&') : null;
            splitted_data && !this.place ? this.getPlace(splitted_data) : '';
        },
        getPlace(data) {
            this.$axios.post('api/places/custom', {id: data[0], attributes: ['id', 'hash', 'title', 'cover', 'country', 'state']})
            .then(res => {
                this.place = res.data
            })
        },
        showFullPhoto(event, photos, active) {
            this.$store.dispatch('setPhotos', {photos: photos, active: active})
            this.$store.dispatch('setPhotosState', true)
        },
        getImageClass(images) {
            let result = '';
            switch (images.length) {
                case 1:
                result = 'size_one';
                break;
                case 2:
                result = 'size_two';
                break;
                case 3:
                result = 'size_tree';
                break;
                case 4:
                result = 'size_four';
                break;
                case 5:
                result = 'size_five';
                break;
                case 6:
                result = 'size_six';
                break;

                default:
                break;
            }
            return result;
        },
    }
}
</script>
<style lang="stylus">
.message
    padding 3px 40px
    position relative
    display flex
    padding-right 120px
    +to-width(800px)
        padding 3px 20px
        padding-right 50px

    &-container
        position relative
        padding-left 65px
        &.full
            +to-width(680px)
                width 100%
    
    &-media
        margin-left -5px
        margin-right -5px
        width 400px
        display flex
        flex-wrap wrap
        +to-width(680px)
            width 100%
        +to-width(520px)
            margin-left -2px
            margin-right -2px

        &__item
            cursor pointer
            width 100%
            height 200px
            border-radius 15px
            background-size cover
            background-position center
            margin 5px
            +to-width(520px)
                height 150px
            &.size_two
                width calc(50% - 10px)
                height 150px
                +to-width(520px)
                    width calc(50% - 4px)
                    height 100px
                    margin 2px
            &.size_tree
                width calc(50% - 10px)
                height 150px
                +to-width(520px)
                    width calc(50% - 4px)
                    height 100px
                    margin 2px
                &:first-child
                    width 100%
                    height 200px
                    +to-width(520px)
                        height 150px
            &.size_four
                width calc(50% - 10px)
                height 150px
                +to-width(520px)
                    width calc(50% - 4px)
                    height 100px
                    margin 2px
            &.size_five
                width calc(50% - 10px)
                height 150px
                +to-width(520px)
                    width calc(50% - 4px)
                    height 100px
                    margin 2px
                &:first-child
                    width 100%
                    height 200px
                    +to-width(520px)
                        height 150px
            &.size_six
                width calc(50% - 10px)
                height 150px
                +to-width(520px)
                    width calc(50% - 4px)
                    height 100px
                    margin 2px
            

    &__replies
        border-left 2px solid #5b769e
        margin-top 5px
        padding-left 10px

        .message
            padding 0
            &__time
                right -30px
            &__avatar
                min-width 35px
                width 35px
                height 35px
            &__content
                padding 0
            &__time
                display none

    &__name
        font-weight 600
        font-size 12px
        color #5b769e
        padding 5px 0

    &__avatar
        min-width 45px
        width 45px
        height 45px
        border-radius 50%
        background-color #333
        background-size cover
        background-position center
        position absolute
        left 0
        top 5px
        cursor pointer

    &__content
        background-color white
        padding 15px 20px
        padding-right 30px
        border-radius 0 15px 15px 15px
        position relative
        // min-width 100%

        span
            &.emoji
                font-size 15px
        p
            font-size 12px
            font-weight 500
            line-height 22px
            word-break break-word
            &:last-child
                padding-bottom 0
        
        a
            color #89b3d2
            color #6badbb
    
    &__time
        position absolute
        right -10px
        transform translate(100%, 0px)
        bottom 0px
        font-size 12px!important
        color #aaa
    
    &__image
        width: 100%
        max-width 400px
        height 300px
        background-size cover
        border-radius 15px
        margin 5px 0
        margin-top 15px
    
    &__viewed
        position absolute
        right 7px
        bottom 4px
        opacity 0.3
        img
            width 18px

    &-place
        display flex
        margin-top 10px
        cursor pointer
        max-width 280px

        &__title
            font-size 13px
            font-weight 600
        
        &__text
            color black

        &__cover
            min-width 50px
            width 50px
            height 50px
            background-size cover
            border-radius 10px
            margin-right 10px
</style>